import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import useAgentLogStream from '../../../hooks/useAgentLogStream';
import TokenUsageMeter from '../components/TokenUsageMeter';

const SOURCE_LABELS = {
  live: 'Live SSE',
  mock: 'Simulated feed',
  connecting: 'Connecting…'
};

function LiveActivityTab({ agent }) {
  const { entries, sourceKind } = useAgentLogStream(agent.id);

  const tokensUsed = agent.tasks * 1250;
  const tokenBudget = 50000;

  return (
    <div className="tab-panel-grid">
      <section className="log-console-card">
        <header className="section-heading">
          <div>
            <h3>Live activity</h3>
            <span>{SOURCE_LABELS[sourceKind] || sourceKind}</span>
          </div>
          <span className={`stream-badge stream-${sourceKind}`} />
        </header>
        <div className="log-console" role="log">
          {entries.length === 0 && <p className="tab-empty">Waiting for activity…</p>}
          {entries.map((entry) => (
            <p className="log-line" key={entry.id}>
              <time>{formatDistanceToNow(new Date(entry.at), { addSuffix: true })}</time>
              <span>{entry.text}</span>
            </p>
          ))}
        </div>
      </section>
      <aside className="side-stack">
        <TokenUsageMeter budget={tokenBudget} used={tokensUsed} />
        <div className="stat-card">
          <span>Tasks today</span>
          <strong>{agent.tasks}</strong>
        </div>
        <div className="stat-card">
          <span>Current progress</span>
          <strong>{agent.progress}%</strong>
        </div>
      </aside>
    </div>
  );
}

export default LiveActivityTab;
